const DESKTOP_WIDTH = 1280;
const SESSION_KEY = 'forced_desktop_mode';

/**
 * Utility to manage the browser viewport for non-responsive RNW apps
 */
export const viewportManager = {
  /**
   * Check if desktop mode is currently forced
   */
  isDesktopModeForced: () => {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  },

  /**
   * Switch viewport to fixed desktop width
   */
  enableDesktopMode: () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', `width=${DESKTOP_WIDTH}`);
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
  },

  /**
   * Restore standard mobile viewport
   */
  disableDesktopMode: () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      sessionStorage.removeItem(SESSION_KEY);
    }
  },

  /**
   * Initialize viewport state on app boot
   */
  init: () => {
    if (viewportManager.isDesktopModeForced()) {
      viewportManager.enableDesktopMode();
    }
  },
};
